module.exports = __webpack_public_path__ + "img/nick-huang.fb3e8ba9.jpeg";